import { render, staticRenderFns } from "./Liquidity.vue?vue&type=template&id=18d11add&"
import script from "./Liquidity.vue?vue&type=script&lang=js&"
export * from "./Liquidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports